import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f9711ae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9711ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9711ae')) {
      api.createRecord('7f9711ae', component.options)
    } else {
      api.reload('7f9711ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f9711ae&scoped=true&", function () {
      api.rerender('7f9711ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/index.vue"
export default component.exports